import { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT } from '../components/library/breakpoints';

const MOBILE_QUERY = `(max-width: ${MOBILE_BREAKPOINT})`;

/**
 * Tracks whether the viewport is at or below MOBILE_BREAKPOINT, updating live
 * as the window is resized.
 * @returns {boolean}
 */
export function useIsMobile() {
    const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches);

    useEffect(() => {
        const media = window.matchMedia(MOBILE_QUERY);
        const listener = () => setIsMobile(media.matches);
        media.addEventListener('change', listener);
        return () => media.removeEventListener('change', listener);
    }, []);

    return isMobile;
}
